import request from '@/utils/request'

export function modifyFpStatus(data) {
  return request({
    url: '/api/station/modifyFpStatus',
    method: 'post',
    data
  })
}

export function getFpDetail(data) {
  return request({
    url: '/api/station/fpDetail',
    method: 'post',
    data
  })
}

export function updateFpConfig(data) {
  return request({
    url: '/api/station/updateFpConfig',
    method: 'post',
    data
  })
}

export function syncProdPrice(data) {
  return request({
    url: '/api/station/syncProdPrice',
    method: 'post',
    data
  })
}

export function list4gFp(data) {
  return request({
    url: '/api/station/list4gFp',
    method: 'post',
    data
  })
}

export function setProdBatch(data) {
  return request({
    url: '/api/station/setProdBatch',
    method: 'post',
    data
  })
}

export function modifyStatusBatch(data) {
  return request({
    url: '/api/station/modifyStatusBatch',
    method: 'post',
    data
  })
}

export function setSamePriceBatch(data) {
  return request({
    url: '/api/station/setSamePriceBatch',
    method: 'post',
    data
  })
}

export function setDifPriceBatch(data) {
  return request({
    url: '/api/station/setDifPriceBatch',
    method: 'post',
    data
  })
}
